import React, { useEffect, useState } from "react";
import { arrayOf, bool, shape, string } from "prop-types";

import blogAdImage from "../../../../../../app/assets/images/menu_ads/blog_menu.png";
import {
  Column,
  Container,
  Dropdown,
  List,
  ListItem,
  ListItemLink,
  Title
} from "../MainNav/Dropdown";
import { useMainNavDropdown } from "../MainNav/hooks";
import LinksList from "../MainNav/LinksList";
import { MostViewedListingImage } from "../MostViewedListing";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const BlogMainNavDropdown = ({
  is_full_width,
  is_wide,
  latest_blogs,
  popular_blogs,
  title
}) => {
  const link = "/blog/";
  const [adImageProps, setAdImageProps] = useState({ src: "", srcSet: "" });
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown({
    event_label: "Blog",
    event_value: ""
  });
  const blogDataGtm = {
    "data-gtm-header-menu": "Blog"
  };
  useEffect(() => {
    setAdImageProps({
      src: blogAdImage
    });
  }, []);
  return (
    <>
      <S.BlogDropdownButton
        ref={dropdownRef}
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        title={title}
      >
        <Dropdown isActive={isActive} role="tooltip">
          <Container isFullWidth={!!is_full_width} isWide={!!is_wide}>
            <Column>
              <Title>Browse</Title>
              <List hasBottomPadding>
                <ListItem>
                  <ListItemLink
                    href="/blog/nyc-housing-market-data/"
                    {...blogDataGtm}
                  >
                    Market Data
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/blog/renting/rental-deals/"
                    {...blogDataGtm}
                  >
                    Rental Deals
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/blog/buying-selling/sales-deals/"
                    {...blogDataGtm}
                  >
                    Sales Deals
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink
                    href="/blog/series/first-time-home-buyer-nyc/"
                    {...blogDataGtm}
                  >
                    First-Time Buyer’s Guide
                  </ListItemLink>
                </ListItem>
                <ListItem>
                  <ListItemLink href="/neighborhoods/" {...blogDataGtm}>
                    Neighborhood Guides
                  </ListItemLink>
                </ListItem>
              </List>
            </Column>
            <Column isLastLong>
              <LinksList
                linkProps={blogDataGtm}
                linksList={latest_blogs}
                title="The latest"
              />
              <LinksList
                linkProps={blogDataGtm}
                linksList={popular_blogs}
                title="Most popular"
              />
            </Column>
            <Column isAdsShort>
              <div>
                <MostViewedListingImage as="div">
                  <ListItemLink
                    data-gtm-header-menu="Resources"
                    data-gtm-header-resource-ad="true"
                    href={link}
                  >
                    <img
                      alt="StreetEasy Reads: Market Data, Home Shopping Guides & More"
                      loading="lazy"
                      {...adImageProps}
                    />
                  </ListItemLink>
                </MostViewedListingImage>
              </div>
            </Column>
          </Container>
        </Dropdown>
      </S.BlogDropdownButton>
    </>
  );
};

BlogMainNavDropdown.propTypes = {
  is_wide: bool,
  is_full_width: bool,
  latest_blogs: arrayOf(
    shape({
      title: string,
      link: string
    })
  ),
  popular_blogs: arrayOf(
    shape({
      title: string,
      link: string
    })
  ),
  title: string
};

BlogMainNavDropdown.defaultProps = {
  is_wide: false,
  is_full_width: false,
  latest_blogs: [],
  popular_blogs: [],
  title: DEFAULT_DROPDOWN_TITLE
};

export default BlogMainNavDropdown;
